// Seller (listing) file-request → real file. Mirrors buyerFileRequest.js: mints
// a hidden seller file-request deal (Drive folder via the deal trigger), links
// it to the listing lead by sourceDealId, and carries the chosen `formType` so
// the Client Portal assembles the property-type-tailored forms (condo/pool/
// multi-family) instead of the generic seller set. One idempotent source of
// truth so the modal and the drawer can't drift or double-create.
// See docs/superpowers/specs/2026-07-14-pre-deploy-file-folder-improvements-design.md
import {
  createFileRequestFromLead,
  updateListingLead,
} from "./firebasefunctions";
import { emailListingRequestRecipients } from "./helper";
import { listClients } from "./leadClients";

// Idempotent: if the lead already links a file (sourceDealId), don't create a
// second one — just (re)flag it. `formType` chooses the portal form set.
export async function requestSellerFile(
  lead,
  user = {},
  { sendForms = false, formType = "" } = {},
) {
  if (lead?.sourceDealId) {
    await updateListingLead(lead.id, {
      fileRequested: true,
      fileRequestedAt: Date.now(),
    });
    return {
      deal: { createdat: Number(lead.sourceDealId), id: String(lead.sourceDealId) },
      reused: true,
      sendForms,
    };
  }

  const primary = listClients(lead).find((c) => c.primary);
  const fr = await createFileRequestFromLead(
    {
      contactId: primary?.contactId || lead.contactId || "",
      contactName: lead.contactName || "",
      assignedAgent: lead.assignedAgent || "",
      assignedAgentName: lead.assignedAgentName || "",
      propertyAddress: lead.propertyAddress || "",
      source: lead.source || "",
      notes: lead.notes || "",
      formType: formType || lead.formType || "",
    },
    "seller",
    user,
  );
  if (!fr?.success || !fr.deal) {
    throw new Error(fr?.error || "Could not create the listing file");
  }

  await updateListingLead(lead.id, {
    sourceDealId: String(fr.deal.createdat),
    fileRequested: true,
    fileRequestedAt: Date.now(),
  });
  // Email the Settings → Notifications request recipients (fire-and-forget).
  emailListingRequestRecipients(fr.deal, user).catch((err) =>
    console.error("Listing request email blast failed:", err),
  );
  return { deal: fr.deal, reused: false, sendForms };
}
